<template>
  <ComboBoxInput
    ref="combobox"
    :value="value"
    :placeholder="placeholder"
    :is-disabled="isDisabled"
    :is-loading="isLoading || isSearching"
    :error-messages="errorMessages"
    :limit="limit"
    :options="processedOptions"
    :search-delay="1000"
    :search-threshold="1"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="fio"
    display-key="lastName"
    @input="$emit('input', $event)"
    @input-change="handleTypedInput"
    @change="handleChange"
    @select="$emit('select', $event)"
    @search="handleSearch"
    @blur="$emit('blur')"
    @focus="$emit('focus')"
  >
    <template #option="{ option }">
      <div v-if="option" class="policyholder-option">
        <p class="policyholder-option__row">
          <strong>ПІБ</strong> {{ option.fio }}
        </p>
        <p class="policyholder-option__row">
          <strong>ІПН</strong> {{ option.identification_number }}
        </p>
        <p class="policyholder-option__row">
          <strong>Дата народження</strong> {{ option.date_of_birth }}
        </p>
      </div>
    </template>
  </ComboBoxInput>
</template>

<script>
import { mapActions } from 'vuex';
import { ComboBoxInput } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Number, Object, null],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Введіть прізвище',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      options: [],
      isSearching: false,
    };
  },
  components: { ComboBoxInput },
  computed: {
    processedOptions() {
      return this.options.map(opt => ({
        ...opt,
        lastName: this.getLastNameUa(opt),
      }));
    },
  },
  methods: {
    ...mapActions('policyholderModule', ['searchPolicyholders']),
    getLastNameUa(policyholder) {
      const nameParts = policyholder?.fio?.split(' ') || [];
      if (nameParts.length === 2 || nameParts.length === 3) {
        return nameParts[0];
      }
      return policyholder?.fio || '';
    },
    handleTypedInput(value) {
      this.$emit('input', value || null);
      this.$emit('change', value || null);
    },
    handleChange(event) {
      if (!event.option) {
        this.$emit('change', null);
        return;
      }

      const lastName = event.option ? this.getLastNameUa(event.option) : null;
      this.$emit('change', lastName);
    },
    async handleSearch(query) {
      if (!query) {
        this.options = [];
        return;
      }

      this.isSearching = true;

      try {
        const results = await this.searchPolicyholders({
          searchText: query,
          customerType: 1,
        });
        this.options = results || [];
      } catch {
        this.options = [];
      } finally {
        this.isSearching = false;
      }
    },
    clear() {
      this.$refs.combobox?.clear();
    },
    focus() {
      this.$refs.combobox?.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.policyholder-option {
  &__row {
    margin: 0;
    font-size: 14px;
    color: #09090B;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    strong {
      font-weight: 600;
      margin-right: 8px;
    }
  }
}
</style>
